export const siteName = '红桃影视';

export const navItems = [
  { id: 'overview', label: '平台概览' },
  { id: 'getting-started', label: '新手指南' },
  { id: 'app', label: 'APP 下载' },
  { id: 'membership', label: '会员与免费' },
  { id: 'troubleshoot', label: '打不开排查' },
  { id: 'address', label: '换地址入口' },
  { id: 'safety', label: '安全提示' },
  { id: 'faq', label: '常见问题' },
];

export const heroStats = [
  { value: '3 步', label: '新手到开播的平均操作步骤' },
  { value: '多端', label: '手机 / 平板 / 电脑均可浏览' },
  { value: '7 类', label: '常见访问问题解决思路' },
];

export const quickLinks = [
  {
    icon: 'ri-download-2-line',
    title: '下载 APP',
    desc: '查看安卓与 iOS 端的正规下载方式、安装被拦截时的处理办法。',
    anchor: 'app',
  },
  {
    icon: 'ri-play-circle-line',
    title: '如何开始观看',
    desc: '从打开入口到进入播放页的完整分步说明，第一次使用也不迷路。',
    anchor: 'getting-started',
  },
  {
    icon: 'ri-vip-crown-2-line',
    title: '会员与免费看',
    desc: '会员包含哪些内容、免登录能看什么，两者差别一次讲清。',
    anchor: 'membership',
  },
  {
    icon: 'ri-error-warning-line',
    title: '打不开怎么办',
    desc: '按现象排查：白屏、一直在加载、提示失效，逐条给出解决方向。',
    anchor: 'troubleshoot',
  },
  {
    icon: 'ri-route-line',
    title: '入口换地址',
    desc: '地址变化时如何辨认官方新入口、如何避免点进仿冒站点。',
    anchor: 'address',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全与防骗',
    desc: '识别假客服、假下载包与索要费用的骗局，保护账号与设备。',
    anchor: 'safety',
  },
];

export const overviewFeatures = [
  {
    icon: 'ri-film-line',
    title: '内容分区清晰',
    desc: '电影、剧集、综艺、动漫等按类型归类，找片路径短，列表与详情页信息完整。',
    accentText: 'text-primary-700',
    accentBg: 'bg-primary-100',
  },
  {
    icon: 'ri-history-line',
    title: '观看记录与续播',
    desc: '登录后会保存播放进度，跨设备也能从上次看到的位置继续，不用手动记集数。',
    accentText: 'text-accent-800',
    accentBg: 'bg-accent-100',
  },
  {
    icon: 'ri-live-line',
    title: '清晰度可切换',
    desc: '根据网络情况在标清、高清、超清之间切换，弱网环境下也能保证播放顺畅。',
    accentText: 'text-secondary-800',
    accentBg: 'bg-secondary-100',
  },
  {
    icon: 'ri-device-line',
    title: '多端体验一致',
    desc: '同一个账号在手机、平板与电脑网页端通用，收藏与偏好会同步更新。',
    accentText: 'text-primary-700',
    accentBg: 'bg-primary-100',
  },
  {
    icon: 'ri-search-eye-line',
    title: '搜索与筛选',
    desc: '支持按片名、演员搜索，也能结合年份、地区、类型筛选，快速定位想看的片子。',
    accentText: 'text-accent-800',
    accentBg: 'bg-accent-100',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '播放体验优化',
    desc: '支持倍速、弹幕开关、投屏与字幕切换，观看习惯可以按自己的偏好设置。',
    accentText: 'text-secondary-800',
    accentBg: 'bg-secondary-100',
  },
];

export const guideSteps = [
  {
    step: '01',
    title: '先确认访问入口',
    desc: '通过自己长期使用的固定入口或收藏夹进入，不要轻信聊天群里临时发出的短链接。入口稳定是后续所有操作的前提。',
  },
  {
    step: '02',
    title: '进入首页浏览内容',
    desc: '首页会按类型展示推荐与最新内容。用顶部的搜索框输入片名，或在分区里按类型浏览，都能快速找到想看的内容。',
  },
  {
    step: '03',
    title: '打开详情页了解信息',
    desc: '详情页包含简介、演职员、集数或片长、清晰度等。确认是自己想看的片子后，再点击播放按钮进入播放页。',
  },
  {
    step: '04',
    title: '选择清晰度并播放',
    desc: '进入播放页后可先选择清晰度。网络一般时先选标清或高清，播放稳定后再切换更高清晰度，能明显减少卡顿。',
  },
  {
    step: '05',
    title: '按需登录以保存记录',
    desc: '登录后才会保存收藏与观看进度。如果只是临时观看，不登录也能浏览大部分内容，但记录不会保留。',
  },
];

export const appPlatforms = [
  {
    platform: 'Android（安卓）',
    icon: 'ri-android-line',
    method: '通过正规应用入口获取安装包',
    points: [
      '下载前核对文件名与应用图标，避免来源不明的第三方包。',
      '若系统提示「禁止安装未知来源应用」，在设置中对该来源单独放行后重试。',
      '安装完成后先别急着授权全部权限，按需开启存储与网络即可。',
    ],
  },
  {
    platform: 'iOS（苹果）',
    icon: 'ri-apple-line',
    method: '优先使用浏览器网页版',
    points: [
      'iOS 通常没有独立的正式安装包，建议直接用 Safari 打开网页版使用。',
      '如需添加到桌面，可使用浏览器「添加到主屏幕」功能，获得接近 APP 的体验。',
      '遇到外区账号相关提示时，切勿购买或借用他人账号，存在安全风险。',
    ],
  },
  {
    platform: '电脑网页端',
    icon: 'ri-computer-line',
    method: '浏览器直接访问',
    points: [
      '推荐使用较新版本的 Chrome、Edge 等主流浏览器。',
      '播放卡顿时先关闭其他占用带宽的程序，再切换清晰度。',
      '浏览器插件有时会拦截播放资源，可临时关闭相关插件后重试。',
    ],
  },
];

export const membershipTabs = [
  {
    key: 'member',
    label: '会员权益',
    icon: 'ri-vip-crown-2-line',
    intro: '开通会员主要解决「看得爽、看得全」的需求，适合经常使用的用户。',
    items: [
      '更高清晰度：解锁超清及以上画质，画面细节更完整。',
      '更少限制：减少播放前的等待与提示，播放更连贯。',
      '更多内容：部分专区内容仅对会员开放。',
      '跨端通用：同一账号在手机与电脑端均可享受权益。',
    ],
  },
  {
    key: 'free',
    label: '免费观看',
    icon: 'ri-gift-line',
    intro: '不打算开通会员也完全可以使用，免费方式适合偶尔观看的用户。',
    items: [
      '大部分基础内容可直接观看，无需额外操作。',
      '默认清晰度通常为标清或高清，满足日常观看。',
      '无需登录即可浏览，适合临时查看。',
      '免费内容可能带有播放前提示，属正常现象。',
    ],
  },
];

export const troubleshootItems = [
  {
    symptom: '页面一直白屏 / 空白',
    cause: '多为浏览器缓存过期或脚本被拦截导致。',
    solutions: [
      '清除浏览器缓存与 Cookie 后重新打开。',
      '换一个浏览器（如 Chrome、Edge）或换一台设备测试。',
      '若使用了广告拦截 / 加速类插件，先临时关闭再试。',
    ],
  },
  {
    symptom: '一直显示加载中，进度条不动',
    cause: '通常是网络到资源节点之间的链路不通畅。',
    solutions: [
      '切换 Wi-Fi 与移动数据，判断是否为单一网络问题。',
      '先降低清晰度，弱网环境下更容易播放成功。',
      '等待几分钟后重试，避开访问高峰时段。',
    ],
  },
  {
    symptom: '提示地址失效 / 找不到页面',
    cause: '访问地址发生了变化，旧地址已不再指向当前服务。',
    solutions: [
      '通过你长期使用的固定入口重新进入。',
      '参考「换地址入口」分区的辨认方法获取新入口方向。',
      '不要点击陌生群聊中临时发出的链接。',
    ],
  },
  {
    symptom: '视频能打开但声音画面不同步',
    cause: '多为设备性能或解码方式与当前清晰度不匹配。',
    solutions: [
      '降低一档清晰度后重新播放。',
      '刷新页面，或退出播放页再进入。',
      '关闭后台占用较高的其他应用后再试。',
    ],
  },
  {
    symptom: '手机端无法安装 / 安装被拦截',
    cause: '系统对未知来源应用的默认限制导致。',
    solutions: [
      '在系统设置中为下载来源单独放行「未知来源应用」权限。',
      '确认安装包完整，必要时重新获取后再次安装。',
      '安装失败可重启设备后重试。',
    ],
  },
  {
    symptom: '搜索不到想看的片子',
    cause: '片名写法差异、别名或该内容当前未上架。',
    solutions: [
      '尝试使用别名、主演名字或上映年份搜索。',
      '在对应类型分区中按筛选条件查找。',
      '若确实没有结果，说明该内容暂未提供，可先观看相近题材。',
    ],
  },
];

export const addressTips = [
  {
    icon: 'ri-bookmark-3-line',
    title: '收藏固定入口',
    desc: '把确认可用的入口加入浏览器收藏夹，以后直接从收藏进入，是避免迷路最有效的做法。',
  },
  {
    icon: 'ri-fingerprint-line',
    title: '认准官方特征',
    desc: '官方页面结构稳定、信息规范。若新地址的排版、文案与平时差异很大，应先停一停再判断。',
  },
  {
    icon: 'ri-link-m',
    title: '警惕临时链接',
    desc: '聊天群里频繁更换的短链最容易被替换为仿冒站点，尽量不要点击来源不明的临时链接。',
  },
  {
    icon: 'ri-refresh-line',
    title: '定期核对更新',
    desc: '入口偶尔会有变化，遇到打不开时先回忆最近是否有更新提示，再按新入口重新进入。',
  },
];

export const safetyTips = [
  {
    title: '官方不会索要密码',
    desc: '任何以「账号异常」「需要验证」为由索要密码、验证码的行为都应高度警惕，官方不会通过私聊向你索要这些信息。',
  },
  {
    title: '不轻信收费客服',
    desc: '冒充客服要求转账、充值或购买「解封服务」的，基本都是骗局，正规服务不会这样收费。',
  },
  {
    title: '下载包要核对来源',
    desc: '只从自己确认过的渠道获取安装包，来源不明的「破解版」「加速版」往往带有风险。',
  },
  {
    title: '保护账号与设备',
    desc: '为设备设置锁屏密码，公共设备使用后及时退出登录，避免账号在陌生设备上被使用。',
  },
];

export const faqCategories = [
  { key: 'all', label: '全部' },
  { key: 'access', label: '访问与入口' },
  { key: 'app', label: 'APP 使用' },
  { key: 'member', label: '会员与免费' },
  { key: 'play', label: '播放问题' },
];

export const faqs = [
  {
    category: 'access',
    q: '红桃影视打不开是什么原因？',
    a: '常见原因有三类：一是本地缓存或插件拦截，可清缓存、换浏览器；二是网络链路不通，可切换网络后重试；三是入口地址发生变化，需要按新入口重新进入。可以先从这三方面依次排查。',
  },
  {
    category: 'access',
    q: '需要换地址时应该怎么做？',
    a: '优先从你长期使用的固定入口或收藏夹进入；若旧入口失效，按「换地址入口」分区的辨认方法确认新入口，避免点击来源不明的临时链接。',
  },
  {
    category: 'access',
    q: '页面提示地址失效，是账号出问题了吗？',
    a: '不是。地址失效通常只表示当前访问的入口已变更，与账号状态无关。通过有效入口重新进入即可，账号信息不会因此丢失。',
  },
  {
    category: 'app',
    q: '安卓手机安装被拦截怎么办？',
    a: '在系统设置中找到「应用安装」或「未知来源应用」相关选项，为安装包来源单独放行后再安装。安装包的完整性与来源可靠同样重要。',
  },
  {
    category: 'app',
    q: 'iOS 有正式 APP 吗？',
    a: 'iOS 端通常以网页版为主，建议使用 Safari 打开网页版；如需桌面入口，可用「添加到主屏幕」的方式获得近似 APP 的体验。',
  },
  {
    category: 'member',
    q: '会员和免费看有什么区别？',
    a: '会员主要在高清晰度、专区内容与播放连贯度上有优势；免费观看可覆盖大部分基础内容，默认清晰度较低，但已能满足日常观看。',
  },
  {
    category: 'member',
    q: '不登录可以用吗？',
    a: '可以浏览与观看大部分基础内容，但不会保存观看记录和收藏。若希望跨设备续播，建议在可信设备上登录。',
  },
  {
    category: 'play',
    q: '播放一直卡顿怎么处理？',
    a: '先降低一档清晰度，再关闭后台占用带宽的程序；如果仍然卡顿，可切换网络或在非高峰时段重试。',
  },
  {
    category: 'play',
    q: '换设备后观看记录还在吗？',
    a: '使用同一账号登录即可同步观看进度与收藏，这也是建议登录的主要原因。',
  },
  {
    category: 'play',
    q: '能投屏到电视上看吗？',
    a: '支持投屏的设备可在播放页找到投屏入口，前提是手机与电视处于同一网络。若列表里找不到设备，可检查两者是否连接到同一个 Wi-Fi。',
  },
];

export const footerLinks = [
  { label: '平台概览', anchor: 'overview' },
  { label: '新手指南', anchor: 'getting-started' },
  { label: 'APP 下载', anchor: 'app' },
  { label: '会员与免费', anchor: 'membership' },
  { label: '打不开排查', anchor: 'troubleshoot' },
  { label: '换地址入口', anchor: 'address' },
  { label: '安全提示', anchor: 'safety' },
  { label: '常见问题', anchor: 'faq' },
];